import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=3088f9ec"
import script from "./LockIcon.vue?vue&type=script&lang=ts"
export * from "./LockIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports